import { motion } from "framer-motion";

/**
 * Small pulsing cyan dot. Click → opens a "Coming soon" drawer placeholder.
 * NOT a chatbot per Team Lead directive.
 */
export default function SmithersPresenceDot({ onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            data-testid="smithers-presence-dot"
            aria-label="Smithers presence"
            className="
                group relative inline-flex items-center gap-2
                px-3 py-2 rounded-full border border-tca-cyan/22
                hover:border-tca-cyan/55 transition-all duration-300
            "
        >
            <span className="relative inline-flex items-center justify-center">
                <motion.span
                    aria-hidden="true"
                    animate={{ scale: [1, 1.55, 1], opacity: [0.6, 0, 0.6] }}
                    transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
                    className="absolute inline-block w-2.5 h-2.5 rounded-full bg-tca-cyan"
                />
                <span className="relative inline-block w-1.5 h-1.5 rounded-full bg-tca-cyan-hi shadow-[0_0_12px_rgba(0,219,255,0.8)]" />
            </span>
            <span className="font-mono-tight text-[10px] uppercase tracking-[0.24em] text-tca-cyan/85 group-hover:text-tca-cyan-hi">
                Smithers
            </span>
        </button>
    );
}
